export default new Intl.Collator(undefined, { numeric: true }).compare
